/* assets/advcoti-fompic-1014.js. NEW FILE, lane SHIP-PREDICT-1014 (14 Oct 2026).
   Bon: "the tube grade fom selector is missing the images for pvs-14 and pvs-31 slider on coti page".
   The dark kit card FOM sliders (round 4, assets/advcoti-lander.js) get the same tier picture the PVS-14 and PVS-31
   pages show (no-buy-fom-<tier>.webp), a small preview that follows the slider, and the same Enlarge pop up as the
   buy box at the top (window.acbFomZoom from assets/advcoti-buy-box.js). It reads the slider's own value and stops
   and presses the slider's own stop buttons, so prices, cart lines and stock stay exactly what the slider does.
   A tier with no picture of its own shows the next lower picture greyed, never a broken image.
   Loaded from snippets/advcoti-buy-box.liquid. Remove the two tags there to undo. NO EM DASHES OR EN DASHES. */
(function () {
  "use strict";
  function num(s) { var m = String(s || "").match(/\d{4}/); return m ? m[0] : ""; }
  function build(box, Z) {
    if (box.hasAttribute("data-r4p-done")) return;
    box.setAttribute("data-r4p-done", "");
    var top = box.querySelector(".r4f__top");
    var row = document.createElement("div");
    row.className = "r4p";
    row.innerHTML = '<button type="button" class="r4p__btn" aria-label="Enlarge the sample view"><img class="r4p__img" alt="" width="64" height="64" decoding="async"></button>' +
      '<span class="r4p__txt"><span class="r4p__cap"></span><span class="r4p__en">Enlarge</span></span>';
    if (top && top.nextSibling) box.insertBefore(row, top.nextSibling); else box.insertBefore(row, box.firstChild);
    var img = row.querySelector("img"), cap = row.querySelector(".r4p__cap");
    var val = box.querySelector("[data-r4-fom-value]");
    function stops() { return Array.prototype.slice.call(box.querySelectorAll("[data-r4-stop]")); }
    function current() { return num(val ? val.textContent : ""); }
    function sync() {
      var f = current(); if (!f) return;
      var p = Z.pic(f, false);
      if (p.url && img.getAttribute("src") !== p.url) img.setAttribute("src", p.url);
      img.classList.toggle("is-dead", !p.own);
      img.setAttribute("alt", "Sample view at " + f + " FOM (illustration)");
      cap.textContent = "Sample view, " + f + " FOM";
    }
    function open() {
      var L = stops().map(function (b) { return { n: num(b.textContent), dead: !!b.disabled }; });
      Z.open({ tiers: L, current: current(), pick: function (n) {
        var b = stops().filter(function (x) { return num(x.textContent) === n; })[0];
        if (b && !b.disabled) b.click();
        sync();
        return current();
      } });
    }
    row.addEventListener("click", function (e) { if (e.target.closest && e.target.closest(".r4p__btn, .r4p__en")) { e.preventDefault(); open(); } });
    if (val && window.MutationObserver) new MutationObserver(sync).observe(val, { childList: true, characterData: true, subtree: true });
    box.addEventListener("click", function () { setTimeout(sync, 0); });
    box.addEventListener("input", function () { setTimeout(sync, 0); });
    sync();
  }
  function init() {
    var Z = window.acbFomZoom;
    if (!Z) return;
    var boxes = document.querySelectorAll("#no-advcoti [data-r4-fom]");
    for (var i = 0; i < boxes.length; i++) { try { build(boxes[i], Z); } catch (e) { if (window.console) console.warn("FOM picture", e); } }
  }
  document.addEventListener("acb:fomzoom", init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  window.addEventListener("load", init);
})();
